import styled from '@emotion/styled'

export const StoreButtonImage = styled.img`
  display: block;
  height: 47px;
  width: 160px;
`
